import React from "react";
import { TriggerForEditor } from "@dots-projects/types";
import TriggerRootFormButtonClick from "./TriggerRootFormButtonClick";
import { Tooltip } from "antd";
import { useTriggerEditorStateDispatch } from "./TriggerEditor";
import TriggerRootFormRoleChange from "./TriggerRootFormRoleChange";
import { CloseCircleOutlined } from "@ant-design/icons";
import { FormLabel } from "./FormLabel";
import TriggerRootFormCommand from "./TriggerRootFormCommand";

export type TriggerRootFormProps = { trigger: TriggerForEditor };

function TriggerRootFormTeamJoin() {
  const { dispatch } = useTriggerEditorStateDispatch();

  const onClose = async () => {
    dispatch({ type: "unselect" });
  };

  return (
    <div className="flex flex-col gap-3 text-left">
      <div className="flex justify-between">
        <FormLabel label={"Trigger: New user joins Discord"}></FormLabel>
        <Tooltip title="Close" placement="bottom">
          <CloseCircleOutlined
            style={{ fontSize: "20px", color: "#6C6C6C" }}
            onClick={onClose}
          />
        </Tooltip>
      </div>
      <div>
        This trigger runs automatically when a new member joins your server.
      </div>
    </div>
  );
}

/**
 * Renders the form for managing trigger configurations. The form shows up when the trigger root node is selected in the flow chart.
 */
export function TriggerRootForm({ trigger }: TriggerRootFormProps) {
  const type = trigger.isDraft ? trigger.liveTriggerConfigs.type : trigger.type;

  switch (type) {
    case "team_join":
      return <TriggerRootFormTeamJoin />;
    case "button_click":
      return <TriggerRootFormButtonClick trigger={trigger} />;
    case "role_change":
      return <TriggerRootFormRoleChange trigger={trigger} />;
    case "command":
      return <TriggerRootFormCommand trigger={trigger} />;
    default:
      break;
  }
  return null;
}
